import { RootState } from 'editor/src/store/index';

const getCanvasWidth = (state: RootState) => state.canvas.width;

export default getCanvasWidth;
